<script lang="ts">
    import Select from "svelte-select"
    import { filterConfig } from "./config"
    import { createEventDispatcher } from "svelte"
    import { _ } from "svelte-i18n"
    export let filter: PriceCalculationExceptionFilter
    let attributeValue = {
        label: filter.attribute ? filterConfig[filter?.attribute]?.label || "UNBEKANNT" : "",
        value: filter.attribute,
    }
    const dispatch = createEventDispatcher()
</script>

<Select
    placeholder="{$_('components.pcalc.attribute')}"
    bind:value="{attributeValue}"
    items="{Object.entries(filterConfig).map(([key, value]) => ({ label: value.label, value: key }))}"
    on:change="{(e) => {
        dispatch('change', { attribute: e.detail.value })
    }}"
    clearable="{false}"
    showChevron="{true}"
>
    <div class="selection" slot="selection" let:selection>
        <div class="selection-label">{$_("components.pcalc.attribute")}</div>
        <div class="selection-value">
            {selection.label}
        </div>
    </div>
</Select>
